if (!customElements.get('dc-product-info-accordions')) {
  class DcProductInfoAccordions extends HTMLElement {
    connectedCallback() {
      if (this._isConnected) {
        return;
      }

      this._isConnected = true;
      this._animations = new Map();
      this._onClick = this._handleClick.bind(this);
      this.addEventListener('click', this._onClick);
    }

    disconnectedCallback() {
      if (!this._isConnected) {
        return;
      }

      this.removeEventListener('click', this._onClick);

      this._animations.forEach((animation, item) => {
        animation.cancel();
        item.classList.remove('is-animating', 'is-closing');
      });

      this._animations.clear();
      this._isConnected = false;
    }

    _handleClick(event) {
      const summary = event.target.closest('.dc-product-info-accordions__summary');

      if (!summary || !this.contains(summary)) {
        return;
      }

      const item = summary.parentElement;

      if (!item?.matches('.dc-product-info-accordions__item')) {
        return;
      }

      event.preventDefault();
      this._toggle(item);
    }

    _toggle(item) {
      if (this._animations.has(item)) {
        return;
      }

      const content = item.querySelector(
        ':scope > .dc-product-info-accordions__content, :scope > .dc-product-info-accordions__faq-list',
      );
      const shouldOpen = !item.open;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!content || reduceMotion || typeof content.animate !== 'function') {
        item.open = shouldOpen;
        return;
      }

      if (shouldOpen) {
        item.open = true;
      } else {
        item.classList.add('is-closing');
      }

      item.classList.add('is-animating');

      const expandedHeight = shouldOpen ? content.scrollHeight : content.getBoundingClientRect().height;
      const keyframes = shouldOpen
        ? [
            { height: '0px', opacity: 0, transform: 'translateY(-5px)' },
            { height: `${expandedHeight}px`, opacity: 1, transform: 'translateY(0)' },
          ]
        : [
            { height: `${expandedHeight}px`, opacity: 1, transform: 'translateY(0)' },
            { height: '0px', opacity: 0, transform: 'translateY(-5px)' },
          ];
      const animation = content.animate(keyframes, {
        duration: 230,
        easing: 'cubic-bezier(0.2, 0.7, 0.2, 1)',
        fill: 'both',
      });

      this._animations.set(item, animation);

      animation.finished
        .then(() => {
          if (this._animations.get(item) !== animation) {
            return;
          }

          if (!shouldOpen) {
            item.open = false;
          }

          animation.cancel();
          item.classList.remove('is-animating', 'is-closing');
          this._animations.delete(item);
        })
        .catch(() => {});
    }
  }

  customElements.define('dc-product-info-accordions', DcProductInfoAccordions);
}
